import { httpV2 } from "@/api";

/**
 * @summary Solicita o resultado do diagnóstico no HSS.
 * @param {number} resultSetId Id do conjunto de resultado.
 * @returns {promise} Retorna status do diagnóstico.
 */
const GetHSSResult = function(resultSetId)
{
	return httpV2.get(`/WindTurbinesDiagnostic/${resultSetId}/HSSMisalignment`);
};

/**
 * @summary Solicita os dados para construção do gráfico do resultado.
 * @param {number} resultSetId Id do conjunto de resultado.
 * @param {number} shaft Região do exio.
 * @returns {promise} Retorna os eixos do gráfico e frequências de interesse.
 */
const GetHSSChart = function(resultSetId, shaft)
{
	return httpV2.get(`/WindTurbinesDiagnostic/${resultSetId}/${shaft}/HSSMisalignment/Chart`);
};

/**
* @summary Solicita o resultado do diagnóstico angular no eixo principal.
* @param {number} resultSetId Id do conjunto de resultado.
* @returns {promise} Retorna status do diagnóstico.
*/
const GetMainShaftAngularResult = function(resultSetId)
{
	return httpV2.get(`/WindTurbinesDiagnostic/${resultSetId}/AngularMisalignmentMainShaft`);
};

/**
* @summary Solicita os dados para construção do gráfico do resultado.
* @param {number} resultSetId Id do conjunto de resultado.
* @returns {promise} Retorna os eixos do gráfico e frequências de interesse.
*/
const GetMainShaftAngularChart = function(resultSetId)
{
	return httpV2.get(`/WindTurbinesDiagnostic/${resultSetId}/AngularMisalignmentMainShaft/Chart`);
};

/**
* @summary Solicita o resultado do diagnóstico paralelo no eixo principal.
* @param {number} resultSetId Id do conjunto de resultado.
* @returns {promise} Retorna status do diagnóstico.
*/
const GetMainShaftParallelResult = function(resultSetId)
{
	return httpV2.get(`/WindTurbinesDiagnostic/${resultSetId}/ParallelMisalignmentMainShaft`);
};

/**
* @summary Solicita os dados para construção do gráfico do resultado.
* @param {number} resultSetId Id do conjunto de resultado.
* @returns {promise} Retorna os eixos do gráfico e frequências de interesse.
*/
const GetMainShaftParallelChart = function(resultSetId)
{
	return httpV2.get(`/WindTurbinesDiagnostic/${resultSetId}/ParallelMisalignmentMainShaft/Chart`);
};

/**
* @summary Solicita o resultado do diagnóstico de desalinhamento paralelo no eixo do gerador.
* @param {number} resultSetId Id do conjunto de resultado.
* @returns {promise} Retorna status do diagnóstico.
*/
const GetGeneratorParallelMisalignmentResult = function(resultSetId)
{
	return httpV2.get(`/WindTurbinesDiagnostic/${resultSetId}/ParallelMisalignmentGeneratorShaft`);
};

/**
* @summary Solicita os dados para construção do gráfico de desalinhamento paralelo no eixo do gerador.
* @param {number} resultSetId Id do conjunto de resultado.
* @returns {promise} Retorna os eixos do gráfico e frequências de interesse.
*/
const GetGeneratorParallelMisalignmentChart = function(resultSetId)
{
	return httpV2.get(`/WindTurbinesDiagnostic/${resultSetId}/ParallelMisalignmentGeneratorShaft/Charts`);
};

export default {
	GetHSSResult,
	GetHSSChart,
	GetMainShaftAngularResult,
	GetMainShaftAngularChart,
	GetMainShaftParallelResult,
	GetMainShaftParallelChart,
	GetGeneratorParallelMisalignmentResult,
	GetGeneratorParallelMisalignmentChart
};